module.exports = __webpack_public_path__ + "static/media/story-12.21966f63.jpg";